import CustomPageTable from './CustomPageTable'

export default CustomPageTable